import SlaMetrics from "../../components/sla-metrics/SlaMetrics.tsx";

export default function SlaMetricsPage() {
  return (
    <div>
      <SlaMetrics />
      <hr />
    </div>
  );
}
